"use client";

import { Icon } from "@fanduel/og-fe-library";
import Image from "next/image";
import InputForm from "./InputForm";
import styles from "./newsletterWidgetBottom.module.scss";
interface NewsletterWidgetBottomProps {
  bodyTextL1?: string;
  bodyTextL2?: string;
  title?: string;
}

const NewsletterWidgetBottom = ({
  title = "Subscribe to our newsletter",
  bodyTextL1 = "Want more stories like this?",
  bodyTextL2 = "Sign up to our newsletter to receive the latest news.",
}: NewsletterWidgetBottomProps) => (
  <div className={styles.container}>
    <div className={styles.content}>
      <Icon iconName="icons.email" iconColor="colorBaseWhite" iconSize={40} />
      <h3>{title}</h3>
      <div className={styles.widgetText}>
        <p>{bodyTextL1}</p>
        <p>{bodyTextL2}</p>
      </div>
      <div className={styles.subscribeAndShare}>
        <InputForm location="bottom" />
      </div>
    </div>
    <div className={styles.imgLeft}>
      <Image
        src="https://cdn.sanity.io/images/pbwem9y5/ch_production/d34479175d292388a6afc16815185708ec0cc379-211x239.png"
        alt="Newsletter Signup"
        width={211}
        height={239}
      />
    </div>
    <div className={styles.imgRight}>
      <Image
        src="https://cdn.sanity.io/images/pbwem9y5/ch_production/81be23f1213fe1f1abcd32df8617b44c52ac80cd-281x239.png"
        alt="Newsletter Signup"
        width={281}
        height={239}
      />
    </div>
  </div>
);
export default NewsletterWidgetBottom;
